import { uniqueId } from "lodash";
import { makeObservable, observable } from "mobx";
import { ExpenseBudgetForm, OurWorkBudgetForm } from "../forms";

class Category {
  budget_category_id: string;
  name: string;
  total_budget: number;
  credit: number;

  constructor(src: {
    budget_category_id: string;
    name: string;
    total_budget?: number | null;
    credit?: number | null;
  }) {
    this.budget_category_id = src.budget_category_id;
    this.name = src.name;
    this.total_budget = src.total_budget ?? 0;
    this.credit = src.credit ?? 0;
  }
}

export class OurWorkCategory extends Category {
  @observable.ref budgetItems: [string, OurWorkBudgetForm][] = [];

  constructor(src: {
    budget_category_id: string;
    name: string;
    total_budget?: number | null;
    credit?: number | null;
  }) {
    // TODO: [mobx-undecorate] verify the constructor arguments and the arguments of this automatically generated super call
    super(src);
    makeObservable(this);
  }

  get key() {
    return `our_work_${this.budget_category_id}`;
  }

  initBudgets(args: ConstructorParameters<typeof OurWorkBudgetForm>[0][]) {
    this.budgetItems = args.map((i) => [uniqueId(), new OurWorkBudgetForm(i)]);
  }

  addBudget(args: ConstructorParameters<typeof OurWorkBudgetForm>[0]) {
    this.budgetItems = [
      [uniqueId(), new OurWorkBudgetForm(args)],
      ...this.budgetItems,
    ];
  }

  removeBudget(itemKey: string) {
    this.budgetItems = this.budgetItems.filter((i) => i[0] !== itemKey);
  }
}

export class ExpenseCategory extends Category {
  real_expenses_without_other: number;
  @observable.ref budgetItems: [string, ExpenseBudgetForm][] = [];

  constructor(
    src: ConstructorParameters<typeof Category>[0] & {
      real_expenses_without_other?: number | null;
    },
  ) {
    super(src);
    makeObservable(this);
    this.real_expenses_without_other = src.real_expenses_without_other ?? 0;
  }

  get key() {
    return `expense_${this.budget_category_id}`;
  }

  initBudgets(args: ConstructorParameters<typeof ExpenseBudgetForm>[0][]) {
    this.budgetItems = args.map((i) => [uniqueId(), new ExpenseBudgetForm(i)]);
  }

  addBudget(args: ConstructorParameters<typeof ExpenseBudgetForm>[0]) {
    this.budgetItems = [
      [uniqueId(), new ExpenseBudgetForm(args)],
      ...this.budgetItems,
    ];
  }

  removeBudget(itemKey: string) {
    this.budgetItems = this.budgetItems.filter((i) => i[0] !== itemKey);
  }
}
